<template>
	<div id="listBox">
		<ul class="listBox">
			<li v-for="item in tableData">
				<p class="name">{{ item.prodectName }}</p>
				<p class="num yellow">{{ item.num }} 张</p>
			</li>
		</ul>
		<p class="p">
			实体卡费用 共计 {{ num }} 张：
			<span class="yellow">￥{{ (allMoney / 100).toFixed(2) }}元</span>
		</p>
		<div class="addr">
			<div class="left">
				<span>选择地址</span>
				<el-select v-model="addrId" placeholder="请选择" @change="addressChange">
					<el-option v-for="item in options" :key="item.id" :label="item.address" :value="item.id"></el-option>
				</el-select>
			</div>
			<el-button class="left" style='margin-left: 20px;' type="primary" @click="centerDialogVisible = true">添加地址</el-button>
		</div>
		<p class="p">
			<el-tooltip effect="dark" content="满200张全国包邮" placement="top" v-if="addrId != 0">
				<span>顺丰到付
					<!-- <span class="yellow">￥{{ yfMoney }}元</span> -->
				</span>
			</el-tooltip>
		</p>
		<div class="beizhu">
			<p>备注：</p>
			<el-input v-model="beizhuText" type="textarea" placeholder="请输入备注"></el-input>
		</div>
		<p class="p">
			费用总计
			<span class="yellow">￥{{ (yfMoney + allMoney / 100).toFixed(2) }}元</span>
		</p>
		<el-button class="btn" type="primary" @click="submitForm1()">确认</el-button>
		<el-dialog title="新增地址" :visible.sync="centerDialogVisible" width="500" center>
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="收件人姓名:" prop="name"><el-input v-model="ruleForm.name"></el-input></el-form-item>
				<el-form-item label="收件人电话" prop="contractNo"><el-input v-model.number="ruleForm.contractNo"></el-input></el-form-item>
				<el-form-item label="收件人地址" prop="address"><el-input v-model="ruleForm.address"></el-input></el-form-item>
				<el-form-item label="收件地邮编" prop="postcode"><el-input v-model="ruleForm.postcode"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false;resetForm('ruleForm');">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="购买成功" :visible.sync="centerDialogVisible3" width="300" center>
			<p>您可以做以下操作</p>
			<span slot="footer" class="dialog-footer">
				<router-link class='aLineBtn' to="/commodity/card">继续购买</router-link>
				<router-link class='aLineBtn' to="/commodity/buyList">查看购买记录</router-link>
			</span>
		</el-dialog>
		<!-- 投保确认 -->
		<el-dialog title="订单确认" :visible.sync="centerDialogVisible1" center>
			<p class="text" style="margin-bottom: 10px;">请选择本单支付方式</p>
			<el-radio-group v-model="radio2">
				<el-radio :label="1" v-if='btnApple && virtualAccount != 1'>线下转账</el-radio>
				<el-radio :label="2" v-if='btnApple1'>立即支付</el-radio>
			</el-radio-group>
			<div class="checkBox" v-if="radio2 == 2">
				<center>出单应付金额：<span class="yellow">￥{{ (yfMoney + allMoney / 100).toFixed(2) }} 元</span></center>
				<div class="check">
					<div class="wx" :class="{active:payIndex == 2}" @click="payIndex=2">微信支付</div>
					<div class="wx zfb" :class="{active:payIndex == 1}" @click="payIndex=1">支付宝支付</div>
				</div>
			</div>
			<span slot="footer">
				<el-button @click="centerDialogVisible1 = false;quxiaoFk()">取 消</el-button>
				<el-button type="primary" @click="topay">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="payIndex == 2? '请使用微信完成付款' : '请使用支付宝完成付款'" :visible.sync="centerDialogVisible2" width="500px" center @closed='quxiaoFk'>
			<center style="line-height: 30px;">出单应付金额：<span class="yellow">￥ {{ (yfMoney + allMoney / 100).toFixed(2) }} 元</span></center>
			<vue-qr name="erwm" class='fukuan' :logoSrc="config.imagePath" :text="payImg" :size="250"></vue-qr>
			<span slot="footer" class="dialog-footer1">
				<el-button class='btn' @click="quxiaoFk()">取 消</el-button>
				<el-button class='btn' type="primary" @click="chongxuan()">刷 新</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { addressList, updateAddress, entityOrder ,topay ,listByDetail,delaypay,submitOrder,fictPay } from '@/axios/api.js';
import vueQr from 'vue-qr'
export default {
	data() {
		var name = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入联系人姓名'));
			} else {
				callback();
			}
		};
		var address = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入联系地址'));
			} else {
				callback();
			}
		};
		var postcode = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入邮政编码'));
			} else {
				callback();
			}
		};
		var contractNo = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			}
			if (!Number.isInteger(value)) {
				callback(new Error('请输入数字值'));
			} else {
				callback();
			}
		};
		return {
			tableData: [],
			allMoney: 0,
			yfMoney: 0,
			options: [],
			beizhuText: '',
			addrId: '',
			num: 0,
			centerDialogVisible: false,
			centerDialogVisible1: false,
			centerDialogVisible2: false,
			centerDialogVisible3:false,
			ruleForm: {
				id: '',
				name: '',
				contractNo: '',
				address: '',
				postcode: ''
			},
			rules: {
				name: [{ validator: name, trigger: 'blur' }],
				contractNo: [{ validator: contractNo, trigger: 'blur' }],
				address: [{ validator: address, trigger: 'blur' }],
				postcode: [{ validator: postcode, trigger: 'blur' }]
			},
			subJosn: [],
			btnApple:true,
			btnApple1:true,
			payIndex:2,//微信还是支付宝
			radio2:2,
			fileList:[],
			config: {
			  imagePath: require('../../assets/img/logo2.png')//中间logo的地址
			},
			payImg:'../../assets/img/djx.png',
			billId:'',
			formInline1:{},
			timer:null,
			virtualAccount:JSON.parse(window.localStorage.getItem("token")).data.obj.virtualAccount,
		};
	},
	components:{
		vueQr
	},
	methods: {
		getData() {
			addressList()
				.then(res => {
					console.log(res);
					this.options = res.data.obj;
					var newAddr={
						address:'自提（免运费）',
						id:0
					}
					this.options.unshift(newAddr)
				})
				.catch(err => {
					console.log(err);
				});
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.postData();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		postData() {
			updateAddress(this.ruleForm)
				.then(res => {
					console.log(res);
					var message = '';
					if (res.data.code == 0) {
						this.$message({
							showClose: true,
							message: '新增地址成功',
							type: 'success'
						});
						this.getData();
						this.centerDialogVisible = false;
						this.resetForm('ruleForm');
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		resetForm(){

		},
		submitForm1() {
			if (this.addrId === '') return this.$message.warning('请选择地址！');
			this.subJosn = [];
			this.tableData.forEach(item => {
				this.subJosn.push({
					productId: item.prodectId,
					billCount: item.num
				});
			});
			var data = {
				addressId: this.addrId,
				remark: this.beizhuText,
				subBill: JSON.stringify(this.subJosn),
				productId: this.subJosn.length ? this.subJosn[0].productId : ''
			};
			entityOrder(data)
				.then(res => {
					if (res.data.code == 0) {
						//this.centerDialogVisible2 = true;
						this.billId=res.data.obj.id;
						if(this.virtualAccount == 1){
							fictPay({billId:this.billId})
							.then(res => {
								console.log(res);
								if(res.data.code == '105033'){
									this.centerDialogVisible1=true;
								}else{
									this.timer=setInterval(() => {
										this.searchStatus(this.billId)
									},1000)
								}
							})
							.catch(err => {
								console.log(err);
							})
						}else{
							this.centerDialogVisible1=true;
						}
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		addressChange() {
			var name=''
			this.options.forEach(item => {
				if(this.addrId == item.id){
					name=item.address
				}
			})
		},
		topay(){//支付方式
			if(this.radio2 == 1){
				var data={
					billId:this.billId
				}
				delaypay(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 0){
						this.centerDialogVisible1 = false;
						this.$message({
							showClose: true,
							message: '线下转账成功！',
							type: 'success'
						});
						this.centerDialogVisible3 = true;
					}
				})
				.catch(err => {
					console.log(err)
				})
			}else{
				var data={
					payType:this.payIndex,
					billId:this.billId
				}
				topay(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 0){
						this.payImg=res.data.obj.qrcodeurl;
						this.centerDialogVisible1 = false;
						this.centerDialogVisible2 = true;
						this.timer=setInterval(() => {
							this.searchStatus(res.data.obj.bill.id)
						},1000)
					}
				})
				.catch(err => {
					console.log(err)
				})
			}
			// this.fileList=[];
			// this.formInline1={ name: '', remark: '', subChannel:''}
		},
		quxiaoFk(){
			clearInterval(this.timer);
			this.centerDialogVisible2 = false;
		},
		searchStatus(id){
			var data={
				billId:id,
				start:0,
				count:100
			}
			listByDetail(data)
			.then(res => {
				console.log(res)
				this.status=res.data.obj.bill.billingState;
				if(this.status == 1){
					this.centerDialogVisible2=false;
					this.centerDialogVisible3=true;
					this.formInline1={ name: '', remark: '', subChannel:''};
					setTimeout(()=> {
						this.lodingTimeBtn=false;
					},2000)
					clearInterval(this.timer);

				}else if(this.status == 4){
					clearInterval(this.timer);
					this.$notify({
					  title: '警告',
					  message: '支付失败',
					  type: 'warning'
					});
					this.centerDialogVisible2=false
				}
			})
			.catch(err => {
				console.log(err)
			})

		},
		chongxuan(){
			clearInterval(this.timer);
			this.centerDialogVisible2 = false;
			this.topay()
		},

	},
	mounted() {
		if (!this.$route.params.data) return this.$router.go(-1);
		this.getData();
		this.tableData = this.$route.params.data;
		this.allMoney = this.$route.params.allMoney;
		this.num = this.$route.params.num;
		if (this.num >= 200) return this.yfMoney = 0;
	}
};
</script>

<style scoped="scoped">
#listBox {
	height: calc(100vh - 130px);
	overflow-y: auto;
	margin: 0 auto;
	position: relative;
}
.listBox {
	margin-top: 20px;
}
.listBox li {
	overflow: hidden;
	line-height: 40px;
	color: #666;
}
.listBox li .name {
	float: left;
}
.listBox li .num {
	float: right;
}
.p {
	text-align: right;
	margin-top: 20px;
}
.addr {
	overflow: hidden;
	margin-top: 30px;
}
.addr .left {
	float: left;
}
.addr .right {
	float: right;
}
.beizhu p {
	margin-bottom: 10px;
}
.btn {
	display: block;
	width: 200px;
	margin: 0 auto;
}
.add {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
.checkBox {
		border: 1px solid #eee;
		padding: 20px 0;
		border-radius: 4px;
		margin-top: 20px;
	}

	.check {
		overflow: hidden;
		width: 320px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.check .wx {
		float: left;
		width: 150px;
		border: 1px solid #eee;
		padding: 10px 0;
		border-radius: 3px;
		text-indent: 50px;
		background: url(../../assets/img/wx.png) 10px center no-repeat;
		cursor: pointer;
	}

	.check .zfb {
		background: url(../../assets/img/zfb.png) 10px center no-repeat;
		margin-left: 20px;
	}

	.check .active {
		border-color: #00ABFA;
	}

	.fukuan{
		width: 200px;
		height: 200px;
		display: block;
		margin: 0 auto;
	}

	.dialog-footer1 .btn {
		width: 150px;
		display: inline-block;
		margin-top: 0;
	}
	.yellow1{padding-left: 20px;}
	.btn2{width: 120px;}
	.pathText1{color: #00ABFA;font-size: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/card/address.vue